<div class="modal-header">
  <h3 class="modal-title">{{'createteam_title' | translate}}</h3>
  <img src="assets/svg/close-button.svg" alt="X" aria-label="Close" class="modal-close-btn" (click)="close()">
</div>
<div class="modal-body">
  <app-add-teams></app-add-teams>
</div>
